import { render, staticRenderFns } from "./TwBenchmarkPostPreviewCell.vue?vue&type=template&id=4d0175c5&scoped=true"
import script from "./TwBenchmarkPostPreviewCell.vue?vue&type=script&lang=ts"
export * from "./TwBenchmarkPostPreviewCell.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmarkPostPreviewCell.vue?vue&type=style&index=0&id=4d0175c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0175c5",
  null
  
)

export default component.exports